import './styles.scss'
import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Container, Row, Col } from 'reactstrap'
import { I18n } from 'react-redux-i18n'
import BannerInfo from './BannerInfo/BannerInfo'
import FormSteps from './FormSteps'
import { useHistory } from 'react-router-dom'
import BannerInfoBtn from './BannerInfoBtn/BannerInfo'
import InfoVerifiedEmail from './InfoVerifiedEmail/InfoVerifiedEmail'
import PanelHelpOverView from './PanelHelp/PanelHelp'
import BtnPanelHelp from '../../../components/BtnPanelHelp/BtnPanelHelp'
import { setUserData } from 'redux/actions/user'
import { operator as operatorApi } from 'api'

const isOkForBilling = (paymentMethod, paymentReferences) => {
  if (paymentMethod === 'wireTransfer') return true
  if (paymentMethod === 'creditCard' && paymentReferences.length > 0) return true

  return false
}

const Overview = ({ company, activeOperator, dispatch, mnemonics }) => {
  const gotoUrl = (url) => {
    history.push(url)
  }

  const infoBtns = [
    {
      key: 'banner_1',
      title: I18n.t('overview_banner_actions_view_conversations_assig'),
      text: I18n.t('overview_banner_actions_text_conversations_empty'),
      textBtn: I18n.t('dashboard_view'),
      handleClick: () => gotoUrl('/dashboard/conversations/assignations'),
      primary: true,
    },
    {
      key: 'banner_5',
      title: I18n.t('overview_banner_actions_view_conversations'),
      text: I18n.t('overview_banner_actions_text_conversations_empty'),
      textBtn: I18n.t('dashboard_view'),
      handleClick: () => gotoUrl('/dashboard/conversations/users'),
    },
    {
      key: 'banner_2',
      title: I18n.t('overview_banner_actions_title_operators'),
      text: I18n.t('overview_banner_actions_text_operators'),
      textBtn: I18n.t('dashboard_invite'),
      handleClick: () => gotoUrl('/dashboard/management/operators/operator'),
      handleHover: () => checkHoverPrimaryBanner(1),
    },
    {
      key: 'banner_3',
      title: I18n.t('overview_banner_actions_title_operators_active'),
      text: I18n.t('overview_banner_actions_text1_operators_active_empty'),
      textBtn: I18n.t('dashboard_view'),
      handleClick: () => gotoUrl('/dashboard/management/operators/'),
      handleHover: () => checkHoverPrimaryBanner(2),
    },
    {
      key: 'banner_4',
      title: I18n.t('overview_banner_actions_title_payment'),
      text: I18n.t('overview_banner_actions_text_payment'),
      textBtn: I18n.t('dashboard_configure'),
      handleClick: () => gotoUrl('/dashboard/configurations/credentials'),
      handleHover: () => checkHoverPrimaryBanner(3),
    },
  ]

  const history = useHistory()
  // const [showModal, setShowModal] = useState(false)
  const [showPanelInfo, setShowPanelInfo] = useState(false)
  const [showBannerInfo, setShowBannerInfo] = useState(true)
  const [currentStep, setCurrentStep] = useState(2)
  const [listInfoBtns, setListInfoButtons] = useState(infoBtns)
  const paymentUrl = `/dashboard/management/company/${company._id}/payment/edit`

  const banners = {
    channels: {
      title: I18n.t('overview_banner_channel_title'),
      text: I18n.t('overview_banner_channel_text'),
      textBtn: I18n.t('dashboard_configure'),
      imgBanner: 'img/banner-channel.png',
      handleClick: (st) => gotoUrl('/dashboard/configurations/channels'),
    },
    payments: {
      title: I18n.t('overview_banner_payment_title'),
      text: I18n.t('overview_banner_payment_text'),
      textBtn: I18n.t('dashboard_add'),
      imgBanner: 'img/banner-payment.png',
      handleClick: (st) => gotoUrl(paymentUrl),
    },
  }

  const checkHoverPrimaryBanner = (index) => {
    if (listInfoBtns[0]?.primary) {
      listInfoBtns[0].primary = false
      setListInfoButtons([...listInfoBtns])
    }
  }

  const listSteps = {
    2: <BannerInfo props={banners.channels}></BannerInfo>,
    3: <BannerInfo props={banners.payments}></BannerInfo>,
  }

  const getCurrentStep = (step) => {
    return listSteps[step]
  }

  const openPanel = () => {
    setShowPanelInfo(!showPanelInfo)
  }

  const hidePanelInfo = () => {
    setShowPanelInfo(false)
  }

  const hideInfoEmail = () => {
    dispatch(setUserData({ firstLogin: false }))
  }

  // logic banners - menu
  useEffect(() => {
    setShowBannerInfo(true)
    if (!company.isSomeChannelConfig) {
      setCurrentStep(2)
    } else if (!isOkForBilling(company.paymentMethod, company.paymentReferences)) {
      setCurrentStep(3)
    } else {
      setShowBannerInfo(false)
    }
  }, [company.isSomeChannelConfig, company.paymentMethod, company.paymentReferences])

  useEffect(() => {
    const index = listInfoBtns.findIndex(el => el.key === 'banner_3')

    operatorApi.operators.getOperatorsOnline().then(({ data: { total } }) => {
      if (total === 0) {
        listInfoBtns[index].text = I18n.t('overview_banner_actions_text1_operators_active_empty')
      } else if (total === 1) {
        listInfoBtns[index].text = `${I18n.t('overview_banner_actions_text1_operators_active')} <span class="badge-total-conv">1</span> ${I18n.t('overview_banner_actions_text2_operator_active')}`
      } else {
        listInfoBtns[index].text = `${I18n.t('overview_banner_actions_text1_operators_active')} <span class="badge-total-conv">${total}</span> ${I18n.t('overview_banner_actions_text2_operators_active')}`
      }

      setListInfoButtons([...listInfoBtns])
    })

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    const indexAssig = listInfoBtns.findIndex(el => el.key === 'banner_1')
    const indexMainPool = listInfoBtns.findIndex(el => el.key === 'banner_5')

    if (mnemonics.totalAssigned === 0) {
      listInfoBtns[indexAssig].text = I18n.t('overview_banner_actions_text_conversations_empty')
    } else if (mnemonics.totalAssigned === 1) {
      listInfoBtns[indexAssig].text = `${I18n.t('dashboard_view')} <span class="badge-total-conv">1</span> ${I18n.t('overview_banner_actions_text_conversations_assig_1')}`
    } else {
      listInfoBtns[indexAssig].text = `${I18n.t('dashboard_view')} <span class="badge-total-conv">${mnemonics.totalAssigned}</span> ${I18n.t('overview_banner_actions_text_conversations_assig_2')}`
    }

    if (mnemonics.totalMainPool === 0) {
      listInfoBtns[indexMainPool].text = I18n.t('overview_banner_actions_text_conversations_empty')
    } else if (mnemonics.totalMainPool === 1) {
      listInfoBtns[indexMainPool].text = `${I18n.t('dashboard_view')} <span class="badge-total-conv">1</span> ${I18n.t('overview_banner_actions_text_conversations_1')}`
    } else {
      listInfoBtns[indexMainPool].text = `${I18n.t('dashboard_view')} <span class="badge-total-conv">${mnemonics.totalMainPool}</span> ${I18n.t('overview_banner_actions_text_conversations_2')}`
    }

    setListInfoButtons([...listInfoBtns])
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mnemonics.totalAssigned, mnemonics.totalMainPool])

  return (
    <div className='animated fadeIn'>
      {activeOperator.firstLogin && <InfoVerifiedEmail onclick={hideInfoEmail}></InfoVerifiedEmail>}

      {false && <BtnPanelHelp handleClick={openPanel}></BtnPanelHelp>}

      {/**New Section */}
      {showBannerInfo && (
        <Container className='new-overview'>
          {/**Header steps */}
          <Row className='cnt-steps'>
            <Col xs={12}>
              <FormSteps step={currentStep}></FormSteps>
            </Col>
          </Row>
          {/**Body steps */}
          <Row className='cnt-view-steps'>
            <Col xs={12}>{getCurrentStep(currentStep)}</Col>
          </Row>
        </Container>
      )}

      {/* */}
      {!showBannerInfo && (
        <Container className='new-overview'>
          <Row>
            <Col xs='12'>
              <h4 className='urs-name'>
                {I18n.t('overview_welcome')} {activeOperator.name}!
              </h4>
              <h1 className='usr-text-info1'>{I18n.t('overview_welcome_action_text')}</h1>
            </Col>
          </Row>
          <Row className='list-banner-btns'>
            <Col xs='12'>
              {listInfoBtns.map((btn, index) => (
                <BannerInfoBtn key={index} props={btn}></BannerInfoBtn>
              ))}
            </Col>
          </Row>
        </Container>
      )}

      {/* Info panel */}
      {showPanelInfo ? <PanelHelpOverView onHide={hidePanelInfo} /> : null}
    </div>
  )
}

export default connect((state) => ({
  company: state.companies,
  activeOperator: state.user,
  mnemonics: state.mnemonics
}))(Overview)
